import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import CenterContent from "../Components/CenterContent/CenterContent";
import InstrumentsWrrapper from "../Components/InstrumentsWrrapper/InstrumentsWrrapper";
import { observer } from "mobx-react-lite"
import { student } from "../store/student.ts" 
import ApplicationsExpect from './../block/applications/ApplicationsExpect';
import ApplicaionsDone from './../block/applications/ApplicationsDone';
import { report } from './../store/report';
import CheckBox from "../Components/CheckBox/CheckBox";
import http from './../Service/http';
import { direction } from "../store/direction";

export const ApplicationContainer = observer(function() {
  const { t, i18n } = useTranslation();
  const getReports = async (id) => {
    const a =await http.post("/report/reportApplicationWait?reportType=" + id )
    report.newReport(a.data.reportApplicationWait);
  }
  useEffect(() => {
      getReports(0)
  },[])

  function setLinks( reportType, id_student, id_group, id_faculty, raion, id_protocols, id_okno_zakaz){
    switch(reportType){
      case 1: 
      return <a onClick={async() => {
                          const res = await http.post("/report/reportApplicationView", {
                            id_okno_zakaz: id_okno_zakaz
                          })
                          if(res.data.ReportsList.result == 1){
                            getReports(report.currentType)
                          }
                        }} className="new_report" target="_blank" href={`/bt/api/r/o-l?gid=${id_group}&id=${id_student}&idp=${id_protocols}&lang=${i18n.language}`}>
          {
            t("st:demand.byPass")
          }
        </a>
      case 2: 
      return <a onClick={async() => {
                          const res = await http.post("/report/reportApplicationView", {
                            id_okno_zakaz: id_okno_zakaz
                          })
                          if(res.data.ReportsList.result == 1){
                            getReports(report.currentType)
                          }
                        }} className="new_report" target={"_blank"} href={`/bt/api/r/v-m?gid=${id_group}&id=${id_student}&idf=${id_faculty}&idr=${raion}&lang=${i18n.language}`} >
          Военкомат
        </a>
      case 3: 
      return <a onClick={async() => {
                          const res = await http.post("/report/reportApplicationView", {
                            id_okno_zakaz: id_okno_zakaz
                          })
                          if(res.data.ReportsList.result == 1){
                            getReports(report.currentType)
                          }
                        }} className="new_report" target="_blank"  href={`/bt/api/r/s-f?gid=${id_group}&id=${id_student}&idf=${id_faculty}&idr=${raion}&lang=${i18n.language}`}>
          Соц. фонд
        </a>
      case 4: 
      return <a onClick={async() => {
                          const res = await http.post("/report/reportApplicationView", {
                            id_okno_zakaz: id_okno_zakaz
                          })
                          if(res.data.ReportsList.result == 1){
                            getReports(report.currentType)
                          }
                        }} className="new_report" target="_blank" href={`/bt/api/r/s-g?gid=${id_group}&id=${id_student}&idf=${id_faculty}&lang=${i18n.language}`}>
        {
          t("st:demand.demandEduc")
        }
      </a>
      case 5: 
      return <a onClick={async() => {
                          const res = await http.post("/report/reportApplicationView", {
                            id_okno_zakaz: id_okno_zakaz
                          })
                          if(res.data.ReportsList.result == 1){
                            getReports(report.currentType)
                          }
                        }} className="new_report" target="_blank" href={`/bt/api/r/l-e?id=${id_student}&lang=${i18n.language}`}> 
        {
          t("st:demand.educLeave")
        }
      </a>
      case 6: 
      return <a onClick={async() => {
                const res = await http.post("/report/reportApplicationView", {
                  id_okno_zakaz: id_okno_zakaz
                })
                if(res.data.ReportsList.result == 1){
                  getReports(report.currentType)
                }
              }} className="new_report" target="_blank" href={`/bt/api/r/t-t?gid=${id_group}&id=${id_student}&idf=${id_faculty}&lang=${i18n.language}`}>
        {
          t("st:demand.trunscript")
        }
      </a>
    }
  }

  return (
    <CenterContent>
      <InstrumentsWrrapper
        leftHead={t("st:instrument.titles.appsExpected")}
        rightHead={t("st:instrument.titles.doneApps")}
        leftChilds={<ApplicationsExpect />}
        rightChilds={<ApplicaionsDone />}/>
      <div className="TableWrapper">
        <table>
          <thead>
            <tr>
              <th style={{ width: '5%' }}>№</th>
              <th style={{ width: '45%', textAlign: 'left' }}>{t("st:table.fio")}</th>
              <th style={{ width: '15%' }}>{t("st:appTitle.titles.group")}</th>
              <th style={{ width: '15%' }}>{t("st:appTitle.titles.doc")}</th>
              <th style={{ width: '15%' }}>{t("st:appTitle.titles.dateApp")}</th>
              {
                direction.leftOrRight == 'left'?
                <th style={{ width: '10%' }}>{t("st:appTitle.titles.status")}</th>
                :
                <th style={{ width: '10%' }}>{t("st:appTitle.titles.doned")}</th>
              }
            </tr>
          </thead>
          <tbody>
            { 
              report.reportExpected.map((item, index) => {
                  return (
                  <tr key={item.id_okno_zakaz} onClick={() => {
                    student.newStudent(item)
                  }}>
                    <td>{index + 1}</td>
                    <td style={{ textAlign: 'left' }}>{item.s_fio}</td>
                    <td>{item.groups}</td>
                    <td style={{ color: "blue" }} >{
                      setLinks(
                        item.id_okno_document,
                        item.id_student,
                        item.id_group,
                        item.id_faculty,
                        item.id_raion,
                        item.id_protocols,
                        item.id_okno_zakaz
                      )
                    }</td>
                    <td>{item.date_insert}</td>
                    {
                      direction.leftOrRight == 'left'? <td style={{display: 'flex', justifyContent: 'center', alignItems: "center"}}>
                      {
                        item.date_viewed ? 
                        <CheckBox onchange={async (e) => {
                          const res = await http.post("/report/reportApplicationUpdate", {
                            id_okno_zakaz: item.id_okno_zakaz,
                            status: 1
                          })
                          if(res.data.result == 1){
                            getReports(report.currentType)
                          }
                        }} checked={item.status} item={item} active = {true}  dsbl = {false} name ='' styles={{ width: "17px" }}/>
                        :
                        <p className="new_report">
                          Новый
                        </p>
                      }
                    </td>:
                    <td style={{display: 'flex', justifyContent: 'center', alignItems: "center"}}>
                      <p className="new_report" style={{ fontWeight: 400 }}>
                        {
                          item.date_viewed
                        }
                      </p>
                    </td>
                    }
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
    </CenterContent>
  );
})
